import {
  useCreateMutation,
  useRoutineAlerts,
  WorkspaceRoutine,
} from '@gripp/shared-logic';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '../../loadingIndicator';
import { AlertForm } from './alertForm';
import { getCounterRoutinesForOnInterval } from './helpers';

type NewAlertFormProps = {
  routineId: string;
  workspaceAssetId: string;
  onClose: () => void;
};
export const NewAlertForm = ({
  routineId,
  workspaceAssetId,
  onClose,
}: NewAlertFormProps) => {
  const { t } = useTranslation();

  const { workspaceAsset, workspaceRoutine, isLoading } = useRoutineAlerts(
    workspaceAssetId,
    routineId
  );

  const [defaultObject, setDefaultObject] = useState<any>(null);
  const [counterRoutines, setCounterRoutines] = useState<WorkspaceRoutine[]>(
    []
  );

  const { mutateAsync: createWorkflow } = useCreateMutation({
    modelName: 'workflow',
    query: CREATE_WORKFLOW,
  });

  useEffect(() => {
    if (!isLoading) {
      const counterRoutines = getCounterRoutinesForOnInterval(workspaceAsset);

      setCounterRoutines(counterRoutines);

      const routineName = workspaceRoutine?.config?.routineButtonText;
      const daysStartDate = moment().format('MM/DD/YYYY');

      const defaultValues = {
        alertLabel: '',
        alertLabelPlaceholder: `${t('alerts.alert')}: ${routineName}`,
        startDate: undefined,
        endDate: undefined,
        minValue: undefined,
        maxValue: undefined,
        alertType: undefined,
        secondAlertType: undefined,
        days: undefined,
        daysStartDate: daysStartDate,
        completions: undefined,
        daysSkipped: undefined,
        onDate: undefined,
        intervalRoutineId: undefined,
        onInterval: undefined,
        onIntervalStart: undefined,
      };

      setDefaultObject(defaultValues);
    }
  }, [isLoading]);

  const submitAlert = async (input: any) => {
    await createWorkflow(
      { input },
      {
        onSuccess: async () => {
          onClose();
        },
      }
    );
  };

  return isLoading || !defaultObject ? (
    <LoadingIndicator />
  ) : (
    <AlertForm
      defaultValues={defaultObject}
      routine={workspaceRoutine}
      counterRoutines={counterRoutines}
      workspaceAsset={workspaceAsset}
      submitAlert={submitAlert}
      onClose={onClose}
      headerTitle="alerts.newAlert"
      backButtonLabel={t('topNav.back')}
      openDropdownOnLoad={true}
    />
  );
};

const CREATE_WORKFLOW = `mutation createWorkflow($input: CreateWorkflowInput!) {
  createWorkflow(input: $input) {
    id
  }
}`;
